import React, { useContext, createContext, useState,useReducer } from "react";
import { Form, Input, Button } from "antd";
import { Link, useHistory } from "react-router-dom";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useAuth } from "@/component/Auth";
import styled from "styled-components";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { storage } from "@/util";
import { LOGININFOSTORE, LOGINTOKEN } from "@/config/const";
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import useRtm from "@/hooks/use-rtm";
import isElectron from "is-electron";
import userIcon from "../../../assets/images/user.svg";
import lockIcon from "../../../assets/images/lock.svg";

const Container = styled.div`
  align-items: center;
  width: 400px;
  border-radius: 16px;
  background: white;
  justify-content: center;
  .atitle {
    display: flex;
    width: 100%;
    align-items: center;
    color: var(--Dark, #0F172A);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    padding-top: 40px;
    padding-bottom: 30px;
    justify-content: center;
  }
  .form {
    width: 280px;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;
  }
  .ant-form-item{
    margin-bottom: 10px;
  }
  .ap {
    position: fixed;
    right: 0;
    bottom: 0;
    width: 100wh;
    height: 30px;
  }
  .buttonLogin {
    border-radius: 16px;
    background: var(--Brand-color, #00AEEF);
  }
  .input{
    height: 35px;
    border-radius: 16px;
    border: 1px solid #ECEEF1;
    margin-top: 5px;
  }
  .tag {
    color: #374151;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: -0.12px;
    padding-left: 15px;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #00AEEF;
    border-color: #00AEEF;
  }
`;

const Login = () => {
  const rtm = useRtm({}, (closedByServer)=>{
    console.log("[Login] closedByServer", closedByServer);
    //关闭rtm
    rtm.logout();
    //退出登录
    storage.remove(LOGININFOSTORE);
    storage.remove(LOGINTOKEN);
    if (isElectron()) {
      alert(`Нэвтрэх хуудас руу чиглүүлж байна!`);
      history.replace("/");
    } else {
      window.location.href = "/";
    }
    alert("Нэвтрэх оролдлого олон удаа хийгдлээ");
  });
  const [autoLogin, setAutoLogin] = useState(false);

  const history = useHistory();
  const auth = useAuth();
  const [form] = Form.useForm();

  const handleSubmit = (values: any) => {
    auth.login(values, () => {
      history.replace("/");
    });
  };

  const [isUserLogin, setIsUserLogin] = React.useState(true);

  const aset = (username: string) => {
    form.setFieldsValue({
      username,
      password: "123456",
    });
  };
  // 在组件挂载时，从localStorage中获取autoLogin的值
  React.useEffect(() => {
    const savedAutoLogin = localStorage.getItem('autoLogin');
    setAutoLogin(savedAutoLogin === 'true');
  }, []);
   // 当用户选择或取消选择自动登录时，将新的值保存到localStorage
   const handleAutoLoginChange = (e:CheckboxChangeEvent) => {
     
    const newAutoLogin = e.target.checked;
    setAutoLogin(newAutoLogin);
    localStorage.setItem('autoLogin', String(newAutoLogin));
    console.log("remember auto login or not:"+localStorage.getItem("autoLogin"))
  };

  React.useEffect(() => {
    const info = storage.get(LOGININFOSTORE);
    if (info.userId) {
      auth.updateLogInfo(info);
      history.replace("/login");
    }
  }, []);

  return (
    <Container>
      {/* <div className="atitle"> */}
        {/* <span
          className={isUserLogin ? "active fir" : "fir"}
          onClick={() => setIsUserLogin(true)}
        >
          Нэвтрэх
        </span> */}
        {/* <span
          className={!isUserLogin ? "active" : ""}
          onClick={() => setIsUserLogin(false)}
        >
          企业登录
        </span> */}
      {/* </div> */}
      <Form onFinish={handleSubmit} form={form} className="form mt30">
        <span className="tag"> Нэвтрэх нэр </span>
        <Form.Item
          name="username"
          rules={[{ required: true, message: "Нэвтрэх нэр хоосон байна" }]}
          // initialValue={"18611385915"}
        >
          <Input className="input" prefix={<img className="mr3 ml3" src={userIcon} alt="userIcon" />} placeholder="Нэвтрэх нэр" />
        </Form.Item>
        <span className="tag"> Нууц үг </span>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Нууц үг хоосон байна" }]}
          // initialValue={"123456"}
        >
          <Input
            className="input"
            prefix={<img className="mr3 ml3" src={lockIcon} alt="lockIcon" />}
            type="password"
            placeholder="Нууц үг"
          />
        </Form.Item>
        <div className="jssb mt30">
        <Checkbox className="ml10" autoFocus={false} checked={autoLogin} onChange={handleAutoLoginChange}>Сануулах</Checkbox>
          <Link to="/losepass">Нууц үг сэргээх</Link>
        </div>

        <Button type="primary" htmlType="submit" block className="mt30 mb10 buttonLogin"  >
          Нэвтрэх
        </Button>
        <div className="mt10 jsc">
          <Link to="/register">Бүртгүүлэх</Link>
        </div>
      </Form>
      {/* <div className="ap">
        <Button size="small" onClick={() => aset("18633931685")}>
          18633931685
        </Button>
        <Button
          size="small"
          className="ml20"
          onClick={() => aset("18611385915")}
        >
          18611385915
        </Button>
        <Button
          size="small"
          className="ml20"
          onClick={() => aset("17600577653")}
        >
          17600577653
        </Button>
      </div> */}
    </Container>
  );
};

export default Login;
